import React from 'react'
import { MultiSelectDropdown, type MultiSelectOption } from '../../../components/MultiSelectDropdown/MultiSelectDropdown'
import { FormFeedback } from '../../../components/Form/FormFeedback'

const MAX_VISIBLE_FP_CODES = 100

export interface ClicFpCodeSelectProps {
  options: MultiSelectOption[]
  selected: string[]
  setSelected: (selected: string[]) => void
  error?: string
  isFetching: boolean
}

export const ClicFpCodeSelect: React.FC<ClicFpCodeSelectProps> = ({ options, selected, setSelected, error, isFetching }) => (
  <>
    <MultiSelectDropdown
      name='metadata.fpCodes'
      className='mw-100'
      options={options}
      initialSelectedOptions={selected}
      onSelectedChanged={setSelected}
      changeOnClose={false}
      searchable
      maxVisibleOptions={MAX_VISIBLE_FP_CODES}
      showRemovableChips
      placeholder='Select FP codes'
      isInvalid={!!error}
      loading={isFetching}
      disabled={isFetching}
    />
    {error ? <FormFeedback>{error}</FormFeedback> : null}
  </>
)
